export const loginSuccessTrackerCookie = 'auth_tool_laststep';
export const BAC_FLOW_ID_COOKIE_KEY = 'flow_id';
